import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGtag from "vue-gtag";


Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueGtag, {
  config: { id: "UA-102839764-3" }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// set initial route
router.replace('/')